import { PersonDto } from 'src/app/api/models';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export const adapter: EntityAdapter<PersonDto> = createEntityAdapter<
  PersonDto
>();

export interface State extends EntityState<PersonDto> {
  // additional entities state properties
  currentUser: PersonDto | null;
  errorText: string | null;
  isAuthenticated: boolean;
}

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  currentUser: null,
  errorText: null,
  isAuthenticated: false
});
